import React from "react";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import { Box, Card, CardContent, CircularProgress } from "@material-ui/core";

const Loading = (props) => {
  return (
    <Wrapper>
      <Card>
        <CardContent>
          <Box m={6}>
            در حال بارگزاری
            <br />
            <br />
            <CircularProgress size={70} />
          </Box>
        </CardContent>
      </Card>
    </Wrapper>
  );
};

export default Loading;
